import { reqGet, reqPost } from './axiosFun';

// 分页查询回调记录
export const callbackRecordPage = (params) => { return reqGet("/callback-record/page", params) };

// 新增回调记录
export const callbackRecordInsert = (params) => { return reqPost("/callback-record/", params) };



// WEBPACK FOOTER //
// ./src/api/callbackRecord.js